export function cardsVideo() {
    function createVideo(card) {
        let src = card.data("src");
        if (src) {
            let videoTemplate = `<video playsinline loop muted>
                                    <source src=${src} type="video/mp4">
                                 </video>`;
            card.append(videoTemplate);
            let video = card.find("video").get(0);
            video.oncanplay = function () {
                card.addClass("loaded-video");
            };
        }
    }

    $(document).on("mouseover", ".cards-grid .image-holder", function () {
        let video = $(this).find("video").get(0);
        if (!video && !$(this).hasClass("loaded-video")) {
            createVideo($(this));
        } else {
            if (video.paused) {
                video.play();
            }
        }
    }).on("mouseleave", ".cards-grid .image-holder", function () {
        let video = $(this).find("video").get(0);
        if (video && !video.paused) {
            video.pause();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/loadedVideo.js